const NotFound = () => {
  return (
    <h1 className="text-center mt-5" style={{ color: "purple" }}>
      error 404 page not found !
    </h1>
  );
};

export default NotFound;
